import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';
import { ThreadObject } from '@/types';

export function useGetPublishedThreads(caseId: string) {
  const { fetchConfigGET } = useGetFetchConfig();

  const getPublishedThreads = async () => {
    if (!caseId) {
      return [];
    }

    const response = await fetch(`${APIBaseChronos}/api/case/${caseId}/threads/published`, fetchConfigGET);
    if (!response.ok) {
      throw new Error('Fetching threads failed');
    }
    return response.json();
  };

  return useQuery<ThreadObject[]>([QueryEntity.PublishedThreads, caseId], getPublishedThreads, {
    refetchOnWindowFocus: false,
  });
}
